import { render, staticRenderFns } from "./QuestionSettings.vue?vue&type=template&id=07b8af82&scoped=true"
import script from "./QuestionSettings.vue?vue&type=script&lang=js"
export * from "./QuestionSettings.vue?vue&type=script&lang=js"
import style0 from "./QuestionSettings.vue?vue&type=style&index=0&id=07b8af82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8af82",
  null
  
)

export default component.exports